export const forZero = (e) => {
  return e < 10 ? `0${e}` : e;
}

export const sumArray = (e) => {
  return e.reduce((a, b) => a + b);
}